module.exports = __webpack_public_path__ + "static/media/profile.a0fc8cfe.webp";